import axios from 'axios';

axios.defaults.headers.common['X-CSRF-TOKEN'] = document.cookie.split("=")[1];

//const baseUrl = 'http://localhost:4810/Api';

export default {
    AddOfficeUsers(OBJ) {
        return axios.post(`/Api/Web/OfficeUsers/Add`, OBJ);
    },
   
    AddTrainers(OBJ) {
        return axios.post(`Api/Web/Trainers/Add`, OBJ);
    },
    loginAccount(OBJ) {
        return axios.post(`/Security/loginUser`, OBJ);
    },
    AddApplications(OBJ) {
        return axios.post(`/Api/Web/Applications/Add`, OBJ);
    },
    GetApplications() {
        return axios.get(`/Api/Web/Applications/Get`);
    },
    Logout() {
        return axios.post(`/Security/Logout`);
    },
    //********************PrintRepoet**********//
    GetCrtificateWPDF(Code, name, nameEng, CertificateData, CertificateId, TrainingFoundationId) {
        debugger;
        return axios.get(
            `Api/Admin/Reports/GetCrtificateWPDF?Code=${Code}&name=${name}&nameEng=${nameEng}&CertificateData=${CertificateData}&CertificateId=${CertificateId}&TrainingFoundationId=${TrainingFoundationId}`
            , {
                responseType: "blob",
            });
    },

    GetCrtificatePDF(Code, name, nameEng, CertificateData, CertificateId, ApprovalId, TrainingFoundationId) {
        return axios.get(
            `Api/Admin/Reports/GetPermissionToPractice?Code=${Code}&name=${name}&nameEng=${nameEng}&CertificateData=${CertificateData}&CertificateId=${CertificateId}&ApprovalId=${ApprovalId}&TrainingFoundationId=${TrainingFoundationId}`, {
            responseType: "blob",
        });
    },

   //***************TrainingFoundations****************//

    AddTrainingFoundations(OBJ) {
        return axios.post(`Api/Web/TrainingFoundations/Add`, OBJ);
    },
    Send(Email) {
        return axios.post(`Api/Web/TrainingFoundations/Send/${Email}`);
    },
    GetVerifiedTrainingFoundations(pageNo, pageSize) {
        return axios.get(`/Api/Web/TrainingFoundations/Get/Verified?pageNo=${pageNo}&pageSize=${pageSize}`)
    },
    GetVerifiedTrainingFoundationsByOfficeID(pageNo, pageSize,officeId) {
        return axios.get(`/Api/Web/TrainingFoundations/GetVerifiedByOfficeID?pageNo=${pageNo}&pageSize=${pageSize}&officeId=${officeId}`)
    },
    GetTrainingFoundationById(trainingFoundationId) {
        return axios.get(`/Api/Web/TrainingFoundations/Get/GetById?trainingFoundationId=${trainingFoundationId}`)
    },
    GetAdvertisement(trainingFoundationId) {
        return axios.get(`/Api/Web/TrainingFoundations/GetAdvertisement?trainingFoundationId=${trainingFoundationId}`)
    },
    //***************Municipalities****************//

    GetMunicipalities() {
        return axios.get(`/Api/Web/Municipality/Get`)
    },
 GetMunicipalitieOffies  (OfficeId)  {
        return axios.get(`/Api/Web/Municipality/GetMunicipality?OfficeId=${OfficeId}`)
    },
    //***************Offices****************//

    GetOffice(municipalityId) {
        return axios.get(`/Api/Web/Offices/Get/${municipalityId}`)
    },
     GetOffices(pageNo, pageSize) {
         return axios.get(`/Api/Web/Offices/Get/All?pageNo=${pageNo}&pageSize=${pageSize}`)
    },
    // /api/Config 
    GetConfig() {
        return axios.get(`/api/Config`)
    },
    
    //***************News****************//

    GetNews(trainingFoundationId) {
        return axios.get(`/Api/Web/News/Get/GetAll?trainingFoundationId=${trainingFoundationId}`)
    },

     //***************JobSeekers****************//

     SendForm(obj) {
        return axios.post(`/Api/Web/JobSeekers/PostJobSeeker`,obj);
      },
      GetRegisteredJobSeekers() {
        return axios.get(`/Api/Web/JobSeekers/GetRegisteredJobSeekers`)
    },
    GetRegisteredJobSeekersByMunicipality(municipalityId) {
        return axios.get(`/Api/Web/JobSeekers/Get/${municipalityId}`)
    },

}